module.exports = __webpack_public_path__ + "img/sti-dest.065d373d.svg";